import { LocalUseField } from './LocalUseField.model';

export class LocalUseResponse {
	isValid: boolean;
	fields: LocalUseField[];
	error: string;

	constructor(init?: Partial<LocalUseResponse>) {
		Object.assign(this, init);
		if (init.fields) {
			this.fields = init.fields.map((field) => new LocalUseField(field));
		}
	}
}
